module.exports = __webpack_public_path__ + "user-privilege.svg?9ee6623146da684707f62b023e4da647";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user-privilege.svg
// module id = 329
// module chunks = 2